import React from 'react'

export default function ConfiguracionPage() {
  return <div />
}
